export function baseUrl() {
	return process.env.RAILS_RELATIVE_URL_ROOT !== undefined ? process.env.RAILS_RELATIVE_URL_ROOT : "";
}